import { render } from "./SfContent.vue?vue&type=template&id=4c399d5a&scoped=true"
const script = {}

import "./SfContent.vue?vue&type=style&index=0&id=4c399d5a&scoped=true&lang=css"

import exportComponent from "/app/10119217139/workspace/IBU-IFSP_PUBLIC/IBU-IFSP-OPENAPI/OPENAPI_WEB_PORTAL_BUILD_GKE_DIRECT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c399d5a"]])

export default __exports__